import { Box } from 'src/design/atoms/Box';
import { Divider } from 'src/design/atoms/Divider';
import { Stack } from 'src/design/atoms/Stack';
import React from 'react';
import { PostCommentDto } from 'src/api/FiretrolApiClient';
import { usePostComments } from 'src/api/queries/posts/usePostComments';
import { CommentValue } from './CommentValue';
import { NewComment } from './NewCommentInput';

interface PostCommentsProps {
  comments: PostCommentDto[];
  postId: string;
  jobId: number | null | undefined;
  shouldPoll?: boolean;
}

export const PostComments: React.FC<PostCommentsProps> = ({
  comments,
  postId,
  jobId,
  shouldPoll = false,
}) => {
  const hasJob = jobId != null && jobId > 0;
  const { data } = usePostComments(jobId, postId, {
    enabled: shouldPoll && hasJob,
    initialData: comments,
  });

  return (
    <Stack gap="xs">
      <Box className="comment-scroll-container">
        {(data ?? comments).map((comment) => (
          <CommentValue key={comment.id} comment={comment} jobId={jobId} />
        ))}
      </Box>
      {hasJob && (
        <>
          <Divider />
          <NewComment postId={postId} jobId={jobId!} />
        </>
      )}
    </Stack>
  );
};
